import { useAmountsContext } from '@components/amounts-received/hooks/use-amounts-context/use-amounts-context.hook'
import { IAmount } from '@components/amounts-received/hooks/use-amounts/use-amounts.hook'
import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './amount.component.scoped.scss'

const Amount = () => {
  const { t } = useTranslation('amounts')
  const navigate = useNavigate()

  const { state }: IAmount = useAmountsContext()
  const { hideValue, amount } = state

  const convertMoneyValue = (number?: number) => {
    return number?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })
  }
  return (
    <div className="amount">
      <div className="value-container">
        <div className="label-value">{t('amountsReceived')}</div>
        <div className="value-formatted">
          <span className="value">{hideValue ? '••••••' : convertMoneyValue(amount)}</span>
        </div>
      </div>
      <div className="button-history">
        <Button onClick={() => navigate('/payments/history')} color="var(--gray)" borderStyle="none" style={{ fontSize: '0.9rem' }}>
          {t('viewHistory')}
        </Button>
      </div>
    </div>
  )
}

export default Amount
